export default {"src":"/_next/static/media/home.fb5ec5ff.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};